export const baseUrl = "https://api.studnerd.com";
// export const baseUrl = "http://127.0.0.1:8000";
// export default baseUrl;
